import React, { useState } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/fire";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email) {
      setError("Email is required.");
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent. Please check your inbox.");
    } catch (error) {
      console.error("Password reset error:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 bg-gradient-to-br from-blue-600 to-teal-400 flex flex-col justify-center items-center p-6 md:p-10 text-white">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 text-center">Forgot Password</h1>
        <p className="text-base md:text-lg text-center">
          Enter your email address to receive a password reset link.
        </p>
      </div>
      <div className="w-full md:w-1/2 flex flex-col justify-center items-center bg-white p-6 md:p-10 shadow-lg">
        <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-gray-700 text-center">Reset Password</h2>
        <form onSubmit={handleResetPassword} className="flex flex-col items-center w-full max-w-md">
          {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
          {message && <p className="text-green-500 mb-4 text-center">{message}</p>}
          
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mb-4 p-3 w-full border border-gray-300 rounded-md shadow focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <button 
            type="submit" 
            className={`w-full bg-blue-500 text-white px-4 py-3 rounded-md hover:bg-blue-600 shadow-lg transition-all duration-300 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
          <Link to="/member-login" className="text-blue-500 mt-4 hover:underline text-center">
            Back to Login
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;